var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-work-item',{attrs:{"work-item-type-name":_vm.workItemTypeName,"is-group":_vm.isGroup},on:{"workItemCreated":_vm.workItemCreated}})
}
var staticRenderFns = []

export { render, staticRenderFns }